import { rankCol, playerCol, divCol, teamCol, teamNameCol, confCol, yearCol, numCol, round3Col } from "./helpers";

const batterStats = [
  numCol("PA", "pa_overall"),
  round3Col("wOBA", "woba_overall"),
  numCol("PA vs RHP", "pa_vs_rhp", "7rem"),
  numCol("PA vs LHP", "pa_vs_lhp", "7rem"),
  round3Col("BA vs RHP", "ba_vs_rhp", "7rem"),
  round3Col("BA vs LHP", "ba_vs_lhp", "7rem"),
  round3Col("wOBA vs RHP", "woba_vs_rhp", "7.5rem"),
  round3Col("wOBA vs LHP", "woba_vs_lhp", "7.5rem"),
  round3Col("OBP", "obp_overall"),
  round3Col("SLG", "slg_overall"),
];

const pitcherStats = [
  numCol("BF", "pa_overall"),
  round3Col("o-wOBA", "woba_overall", "7rem"),
  numCol("BF vs RHH", "pa_vs_rhh", "7rem"),
  numCol("BF vs LHH", "pa_vs_lhh", "7rem"),
  round3Col("o-BA vs RHH", "ba_vs_rhh", "7.5rem"),
  round3Col("o-BA vs LHH", "ba_vs_lhh", "7.5rem"),
  round3Col("o-wOBA vs RHH", "woba_vs_rhh", "8rem"),
  round3Col("o-wOBA vs LHH", "woba_vs_lhh", "8rem"),
  round3Col("o-OBP", "obp_overall"),
  round3Col("o-SLG", "slg_overall"),
];

export const columnsSplitsBatter = [
  rankCol(), playerCol(), teamCol(), confCol(), divCol(), yearCol(),
  ...batterStats,
];

export const columnsSplitsPitcher = [
  rankCol(), playerCol(), teamCol(), confCol(), divCol(), yearCol(),
  ...pitcherStats,
];

export const columnsSplitsBattingTeam = [
  rankCol(), teamNameCol(), confCol(), divCol(), yearCol(),
  ...batterStats,
];

export const columnsSplitsPitchingTeam = [
  rankCol(), teamNameCol(), confCol(), divCol(), yearCol(),
  ...pitcherStats,
];
